import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();
export const getPlatform = () => Capacitor.getPlatform(); // 'android' | 'ios' | 'web'
export const isAndroid = () => Capacitor.getPlatform() === 'android';
export const isIos = () => Capacitor.getPlatform() === 'ios';
